module.exports = __webpack_public_path__ + "assets/img/14_897_big.9130ca61.jpg";